// @file: src/pages/scales/RescueUnit.js
// Componente de unidade de resgate da escala da TV (UR)

import { Container } from "./styles";

const RescueUnit = ({ scale }) => {
  // Garante que sempre temos um array, mesmo se vier null/undefined da API
  const fighters =
    scale && Array.isArray(scale.fighters_scales) ? scale.fighters_scales : [];

  // Se não houver scale (falha de API ou dado inconsistente), evita quebrar a tela
  if (!scale) {
    return null;
  }

  return (
    <Container className="col-sm col-md-3 text-center p-2">
      <h5>UR / {scale.vehicle?.number}</h5>

      <h6>MOTORISTA</h6>
      <p>{fighters[0]?.fighter?.nickname}</p>

      <h6>SOCORRISTA 01</h6>
      <p>{fighters[1]?.fighter?.nickname}</p>

      <h6>SOCORRISTA 02</h6>
      <p>{fighters[2]?.fighter?.nickname}</p>
    </Container>
  );
};

export default RescueUnit;
